import React from 'react'

import Header from './templates/Header';
import Footer from './templates/Footer';
import SEO from './templates/SEO';

function Refund() {
  return (
    <div>
      
<SEO title="Refund & Policy Page"/>

<Header/>



<div class="aboutarea__5 sp_bottom_100">
            <div class="container">
                <div class="row">

                <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 mx-auto">


<div class="blog__details__content__wraper">

    <div class="course__list__wraper aos-init aos-animate" data-aos="fade-up">

    <div class="blog__details__heading__2">
            <h3>Refund Policy</h3>
            <h6>Effective Date : 01-04-2025</h6>
        </div>
    

<div class="experence__description">
                    <p class="description__1">At <strong className='text-white'>Trading Whales,</strong>we strive to provide the best quality education and learning experience. We value your satisfaction, and our refund policy is designed to be transparent and fair.
                    </p>
                    <h5>1. General Policy</h5>
                    <p class="description__2">All payments made for courses, workshops, or services at Trading Whales are non-refundable, except as explicitly stated in special cases or promotional offers.
                    </p>
              

                    <h5>2. No Refunds After Course Access</h5>
                    <p class="description__3">Once a user has received access to any course material—online or offline (including login credentials, study materials, videos, PDFs, etc.)—no refund will be issued.
                 
                       </p>
                    
                    <h5>3. Eligibility for Refund (If Applicable)</h5>
                    <p className='description_3'>You may be eligible for a refund only under the following conditions: <br />
                    
                    Duplicate payment made for the same course.<br />
                    Technical issues resulting in non-delivery of the course after successful payment (with valid proof). <br />
                    Cancellations made before course access is provided. <br />

                    All refund requests must be submitted within 48 hours of the transaction.
                    
                    </p>
                    
                    <h5>4. How to Request a Refund</h5>
                    <p className='description_3'>To initiate a refund request, please contact our support team at: <br />

                    <a href="mailto:info@tradingwhales.in">info@tradingwhales.in</a> <br />
                    <a href="tel:+91 9491065567">+91 94910 65567</a> <br />

                    Please include: <br />
                    Full name <br />
                    Registered email ID <br />
                    Course name <br />
                    Payment details (transaction ID, date) <br />
                    Reason for the refund <br />

                    </p>
                    
                    <h5>5. Refund Processing Time</h5>
                    <p className='description_3'>Once approved, refunds will be processed within 7–10 business days to the original payment method. Processing time may vary based on your payment provider.
  
                    </p>
                    
                    <h5>6. No Refunds for the Following</h5>
                    <p className='description_3'>Change of mind after purchase  <br />
                    Inability to attend live/offline sessions (recordings or catch-up support may be provided) <br />
                    Lack of participation or engagement <br />
                    Disagreement with teaching style or course content after access <br />

                    </p>
                    
                    <h5>7. Cancellation of Courses</h5>
                    <p className='description_3'>In the rare event that Trading Whales cancels a course due to unforeseen circumstances, a full refund will be issued automatically.
                    </p>
                    
                  
                    <p>We appreciate your understanding and cooperation. By enrolling in our courses, you acknowledge and agree to abide by this Refund Policy.</p>
                    <p className='description_3'>For any questions, feel free to contact us.
                    </p>
                    <a href="mailto:info@tradingwhales.in">info@tradingwhales.in</a> <br />
                    <a href="tel:+91 9491065567">+91 94910 65567</a>



                     </div>

    </div>



</div>
</div>


 </div>
 </div>         
       </div>




<Footer/>
    </div>
  )
}

export default Refund
